import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
export function Benefits() {
  const benefits = ['Dar clases de educación financiera con contenido ACTUAL, claro y listo para usar', 'Tener actividades, proyectos y evaluaciones sin preparar nada adicional', 'Conectar con tus alumnos usando casos reales, simuladores y dilemas financieros de su vida cotidiana', 'Organizar TODO tu año sin improvisar', 'Ahorrar horas de trabajo todas las semanas'];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <h2 className="text-xl md:text-3xl font-black text-center mb-6 text-white uppercase tracking-tight" data-id="element-26">
          ✅ CON ESTE KIT VAS A PODER:
        </h2>

        <div onClick={scrollToCompra} className="bg-brand-card border-2 border-brand-accent/40 rounded-lg p-5 md:p-7 shadow-[0_0_25px_rgba(34,197,94,0.15)] cursor-pointer hover:border-brand-accent hover:shadow-[0_0_35px_rgba(34,197,94,0.3)] transition-all" data-id="element-27">
          <div className="space-y-3.5" data-id="element-28">
            {benefits.map((benefit, i) => <div key={i} className="flex items-start" data-id="element-29">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-brand-accent mr-3 shrink-0 mt-0.5 drop-shadow-[0_0_8px_rgba(34,197,94,0.6)]" data-id="element-30" />
                <p className="text-sm md:text-base text-gray-100 font-bold leading-relaxed" data-id="element-31">
                  {benefit}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}